// extracted by mini-css-extract-plugin
module.exports = {"dataTablePro":"SortModal_dataTablePro__3_AaE","sortModal":"SortModal_sortModal__26y6E","ant-modal-content":"SortModal_ant-modal-content__2t-q_"};